const translations = {
  fr: {
    tutorials: {
      tutorialPageTitle: 'Tutoriels',
      invitation: 'Invitation',
      access: 'Accès',
      menu: 'Navigation',
      dashboard: 'Tableau de bord',
      proposals: 'Campagnes proposées',
      campaigns: 'Campagnes achetées',
      createCampaign: 'Créer une campagne',
      addBroadcastTime: 'Ajouter des heures de diffusion',
      campaignPerformance: 'Accéder à la performance d\'une campagne',
      completeCampaign: 'Terminer une campagne',
    },
  },
  en: {
    tutorials: {
      tutorialPageTitle: 'Tutorials',
      invitation: 'Invitation',
      access: 'Access',
      menu: 'Navigation',
      dashboard: 'Dashboard',
      proposals: 'Proposals',
      campaigns: 'Campaigns',
      createCampaign: 'Create a campaign',
      addBroadcastTime: 'Add broadcast times',
      campaignPerformance: 'Access the performance of a campaign',
      completeCampaign: 'Complete a campaign',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/advertisers/modules/tutorials/i18n/tutorials.js